import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import Subcontractor from "../app/components/Invoices/Subcontractor";
import Recruiter from "../app/components/Invoices/Recruiter";
import Agency from "../app/components/Invoices/Agency";
import { getFieldData } from "../services/appService";
import { getFilterCandidates, loadCandidatesByFilter } from "../app/store/candidate";

export default function TimeLogManagement(props) {
  const { item, candidateObj, pType } = props;

  const [activeTab, setActiveTab] = useState(0);

  const perfData = candidateObj?.performerData;
  const entType = candidateObj
    ? getFieldData(perfData, "candidateonboardingform", "CandidateEntity")
    : "";

  const showTab0 = entType === "C2C Basis" || pType === "timelog";
  const showTab1 = candidateObj?.recruiter !== null && pType !== "timelog";
  const showTab2 = pType !== "timelog";

  useEffect(() => {
    let dfKey = 0;
    if (showTab0) {
      dfKey = 0;
    } else if (showTab1) {
      dfKey = 1;
    } else if (showTab2) {
      dfKey = 2;
    }
    setActiveTab(dfKey);
  }, [candidateObj, pType, showTab0, showTab1, showTab2]);

  return (
    <>
      <style>{`
        /* Premium Tabs Styling (Custom WorkflowUser Tabs) */
        .wf-tab-bar {
          display: flex !important;
          align-items: stretch !important;
          gap: 8px !important;
          border-bottom: 2px solid #f1f5f9 !important;
          margin-bottom: 0 !important;
          padding: 8px 4px 0 !important;
          position: relative !important;
          flex: 0 0 auto !important;
        }

        .wf-tab-btn {
          position: relative !important;
          display: inline-flex !important;
          align-items: center !important;
          gap: 7px !important;
          border: none !important;
          background: transparent !important;
          padding: 9px 16px 11px !important;
          font-size: 13.5px !important;
          font-weight: 600 !important;
          color: #64748b !important;
          cursor: pointer !important;
          border-radius: 8px 8px 0 0 !important;
          transition: color 0.2s ease, background 0.2s ease !important;
          outline: none !important;
          white-space: nowrap !important;
        }

        .wf-tab-btn i {
          font-size: 13px !important;
          color: #94a3b8 !important;
          transition: color 0.2s ease !important;
        }

        .wf-tab-btn:hover {
          color: #1e293b !important;
          background: rgba(37, 99, 235, 0.04) !important;
        }

        .wf-tab-btn:hover i {
          color: #475569 !important;
        }

        .wf-tab-btn:focus,
        .wf-tab-btn:focus-visible,
        .wf-tab-btn:active {
          outline: none !important;
          box-shadow: none !important;
          border-color: transparent !important;
        }

        .wf-tab-btn.active {
          color: #2563eb !important;
          font-weight: 700 !important;
        }

        .wf-tab-btn.active i {
          color: #2563eb !important;
        }

        .wf-tab-btn::after {
          content: "" !important;
          position: absolute !important;
          bottom: -2px !important;
          left: 0 !important;
          right: 0 !important;
          height: 2px !important;
          background: #2563eb !important;
          border-radius: 2px 2px 0 0 !important;
          transform: scaleX(0) !important;
          transition: transform 0.25s cubic-bezier(0.4, 0, 0.2, 1) !important;
        }

        .wf-tab-btn.active::after {
          transform: scaleX(1) !important;
        }

        /* Tab content panels */
        @keyframes tabFadeIn {
          from { opacity: 0; transform: translateY(6px); }
          to   { opacity: 1; transform: translateY(0); }
        }

        .wf-tab-panel {
          animation: tabFadeIn 0.28s cubic-bezier(0.16, 1, 0.3, 1) both !important;
          flex: 1 1 auto !important;
          min-height: auto !important;
          overflow-y: visible !important;
          overflow-x: hidden !important;
          padding-right: 4px !important;
          margin-top: 16px !important;
        }
      `}</style>

      <div className="wf-tab-bar">
        {showTab0 && (
          <button
            className={`wf-tab-btn${activeTab === 0 ? " active" : ""}`}
            onClick={() => setActiveTab(0)}
          >
            <i className="fa fa-clock-o" />
            {entType === "C2C Basis" && pType === "invoice"
              ? "Subcontractor"
              : "Time Log Management"}
          </button>
        )}

        {showTab1 && (
          <button
            className={`wf-tab-btn${activeTab === 1 ? " active" : ""}`}
            onClick={() => setActiveTab(1)}
          >
            <i className="fa fa-user-circle-o" />
            Recruiter
          </button>
        )}

        {showTab2 && (
          <button
            className={`wf-tab-btn${activeTab === 2 ? " active" : ""}`}
            onClick={() => setActiveTab(2)}
          >
            <i className="fa fa-building-o" />
            Agency/Client
          </button>
        )}
      </div>

      {/* Custom Tab Panels */}
      {showTab0 && activeTab === 0 && (
        <div className="wf-tab-panel">
          <Subcontractor candidate={candidateObj} ptype={pType} entType={entType} />
        </div>
      )}

      {showTab1 && activeTab === 1 && (
        <div className="wf-tab-panel">
          <Recruiter candidate={candidateObj} ptype={pType} entType={entType} />
        </div>
      )}

      {showTab2 && activeTab === 2 && (
        <div className="wf-tab-panel">
          <Agency candidate={candidateObj} ptype={pType} entType={entType} />
        </div>
      )}
    </>
  );
}
